// return a well-known location with feature properties cloned
export const getWellKnownLocation = (wellKnownLocation: string) => {

    // clear cache to ensure we get a fresh untouched copy
    delete require.cache[require.resolve(`../../map/well-known-locations/${wellKnownLocation}.json`)];

    return require(`../../map/well-known-locations/${wellKnownLocation}.json`);
};
